/**
 * @file: predefinedHitSlops.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Insets } from 'react-native';

export function makeHitSlop(x: number, y = x): Insets {
  return {
    left: x,
    top: y,
    right: x,
    bottom: y,
  };
}

export const PredefinedHitSlops = {
  small: makeHitSlop(4),
  medium: makeHitSlop(8),
  large: makeHitSlop(12),
  extraLarge: makeHitSlop(16),
  vSmall: makeHitSlop(0, 4),
  vMedium: makeHitSlop(0, 8),
  vLarge: makeHitSlop(0, 12),
  hSmall: makeHitSlop(4, 0),
  hMedium: makeHitSlop(8, 0),
  hLarge: makeHitSlop(12, 0),
};
